import type { ChatMessage, ClientState, Enrichment, LeadFields } from "./types";

const KEY = (site: string, k: string) => `mxch:${site}:${k}`;

function uuid(): string {
  return crypto.randomUUID();
}

// Verwijder markdown-bold (**...**) en headers (#) uit chat-output.
// We laten enkele *italics* met rust om mid-stream geen halve woorden te eten.
function stripMarkdown(s: string): string {
  return s
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/`([^`]+)`/g, "$1");
}

const EMPTY_STATE: ClientState = { label_doel: null, wensen: [], taken: [] };

export class Store {
  readonly visitorId: string;
  conversationId: string | null = null;
  messages: ChatMessage[] = [];
  lead: LeadFields = {};
  clientState: ClientState = { ...EMPTY_STATE };
  enrichment: Enrichment | null = null;

  constructor(public readonly site: string) {
    const k = KEY(site, "visitor_id");
    let id = localStorage.getItem(k);
    if (!id) {
      id = uuid();
      localStorage.setItem(k, id);
    }
    this.visitorId = id;
  }

  get consentToken(): string | null {
    return localStorage.getItem(KEY(this.site, "consent"));
  }
  set consentToken(v: string | null) {
    if (v == null) localStorage.removeItem(KEY(this.site, "consent"));
    else localStorage.setItem(KEY(this.site, "consent"), v);
  }

  get wideMode(): boolean {
    const stored = localStorage.getItem(KEY(this.site, "wide"));
    return stored === null ? true : stored === "1";
  }
  set wideMode(v: boolean) {
    localStorage.setItem(KEY(this.site, "wide"), v ? "1" : "0");
  }

  get pandOpen(): boolean {
    const stored = localStorage.getItem(KEY(this.site, "pand-open"));
    return stored === null ? true : stored === "1";
  }
  set pandOpen(v: boolean) {
    localStorage.setItem(KEY(this.site, "pand-open"), v ? "1" : "0");
  }

  appendMessage(m: ChatMessage): void {
    this.messages.push(m);
  }

  appendAssistantText(text: string): void {
    const last = this.messages[this.messages.length - 1];
    if (last?.role === "assistant") last.content += text;
    else this.messages.push({ role: "assistant", content: text });
    // Strip markdown bold/italic asterisks zodra het laatste teken een woordsplitsing maakt
    if (last?.role === "assistant") last.content = stripMarkdown(last.content);
  }

  mergeLead(update: LeadFields): void {
    this.lead = { ...this.lead, ...Object.fromEntries(Object.entries(update).filter(([_, v]) => v != null && v !== "")) };
  }

  setClientState(s: ClientState): void {
    this.clientState = s;
  }

  setEnrichment(e: Enrichment): void {
    this.enrichment = e;
  }
}
